<div class="modal-box-large">
    <div class="d-flex flex-column justify-content-start">
        @if (isPrevidential && userActivityScope === 'pagatore') {
            <h4>Inserimento Pagatore</h4>
        } @else {
            <h4>Inserimento beneficiario</h4>
        }
        <div class="form-container" *ngIf="!isPrevidential">
            <app-basic-form [form]="beneficiaryForm" [keys]="beneficiaryFormKeys"></app-basic-form>
            <ng-container *ngIf="showSpecificBeneficiaryForms">
                <ng-container *ngIf="showIndividualForm; else legalSubjectTemplate">
                    <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                    <app-basic-form [form]="individualRegistryForm" [keys]="individualRegistryFormKeys"></app-basic-form>
                    <h6 class="card-header-label" style="padding: 1em;">Dati di nascita</h6>
                    <app-basic-form [form]="individualBirthForm" [keys]="individualBirthFormKeys"></app-basic-form>
                    <h6 class="card-header-label" style="padding: 1em;">Dati di recapito</h6>
                    <app-basic-form [form]="individualAddressForm" [keys]="individualAddressFormKeys"></app-basic-form>
                    <h6 class="card-header-label" style="padding: 1em;">Dati di contatto</h6>
                    <app-basic-form [form]="individualContactForm" [keys]="individualContactFormKeys"></app-basic-form>
                </ng-container>
                <ng-template #legalSubjectTemplate>
                    <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                    <app-basic-form [form]="legalRegistryForm" [keys]="legalRegistryFormKeys"></app-basic-form>
                    <h6 class="card-header-label" style="padding: 1em;">Dati di recapito</h6>
                    <app-basic-form [form]="legalAddressForm" [keys]="legalAddressFormKeys"></app-basic-form>
                    <h6 class="card-header-label" style="padding: 1em;">Dati della sede legale</h6>
                    <app-basic-form [form]="legalOfficeAddressForm" [keys]="legalOfficeAddressFormKeys"></app-basic-form>
                </ng-template>
            </ng-container>
        </div>
        <mat-tab-group [(selectedIndex)]="beneficiarySearchTabIndex" *ngIf="isPrevidential" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="500ms">
            <mat-tab label="{{matTabLabel}}">
                <div class="form-container">
                    <app-basic-form [form]="beneficiaryForm" [keys]="beneficiaryFormKeys"></app-basic-form>
                    <ng-container *ngIf="showSpecificBeneficiaryForms">
                        <ng-container *ngIf="showIndividualForm; else legalSubjectTemplate" >
                            <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                            <app-basic-form [form]="individualRegistryForm" [keys]="individualRegistryFormKeys"></app-basic-form>
                            <h6 class="card-header-label" style="padding: 1em;">Dati di nascita</h6>
                            <app-basic-form [form]="individualBirthForm" [keys]="individualBirthFormKeys"></app-basic-form>
                            <ng-container *ngIf="userActivityScope === 'beneficiario_previdenziale'">
                                <h6 class="card-header-label" style="padding: 1em;">Dati di residenza</h6>
                                <app-basic-form [form]="individualAddressForm" [keys]="individualAddressFormKeys"></app-basic-form>
                            </ng-container>
                        </ng-container>
                        <ng-template #legalSubjectTemplate>
                            <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                            <app-basic-form [form]="legalRegistryForm" [keys]="legalRegistryFormKeys"></app-basic-form>
                            <h6 class="card-header-label" style="padding: 1em;">Dati della sede legale</h6>
                            <app-basic-form [form]="legalOfficeAddressForm" [keys]="legalOfficeAddressFormKeys"></app-basic-form>
                        </ng-template>
                        <ng-container *ngIf="userActivityScope === 'pagatore'">
                            <h6 class="card-header-label" style="padding: 1em;">Dati documenti</h6>
                            <app-basic-form [form]="documentsForm" [keys]="documentsFormKeys"></app-basic-form>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-tab>
            <mat-tab label="Ricerca soggetto">
                <div [ngClass]="!searchedSubjects ? 'search-form-container' : 'form-container'">
                    <div class="form-container">
                        <app-basic-form [form]="searchSubjectBeneficiaryTypeForm"
                            [keys]="searchSubjectBeneficiaryTypeFormKeys"></app-basic-form>
                        <ng-container *ngIf="showIndividualSearchForm">
                            <h6 class="card-header-label" style="padding: 1em;">Campi ricerca persona fisica</h6>
                            <app-basic-form [form]="searchSubjectForm" [keys]="searchSubjectFormKeys"></app-basic-form>
                        </ng-container>
                        <ng-container *ngIf="showLegalSearchForm">
                            <h6 class="card-header-label" style="padding: 1em;">Campi di ricerca persona giuridica</h6>
                            <app-basic-form [form]="searchSubjectLegalForm" [keys]="searchSubjectLegalFormKeys"></app-basic-form>
                        </ng-container>
                        <button mat-raised-button color="primary" (click)="onSearchClick()" [disabled]="!searchSubjectForm.valid">{{'ricerca' | uppercase}}</button>
                        <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
                    </div>
                </div>
                <ng-container *ngIf="dataSource && dataSource.length > 0">
                    <app-basic-card class="w-100">
                        <app-be-paginated-table *ngIf="showIndividualSearchForm" class="w-100" [dataSource]="dataSource" [tableKeys]="tableKeys"
                            (itemSelected)="onItemSelected($event)" (changeRequested)="onTableChange($event)" (actionSelected)="actionSelected($event)">
                        </app-be-paginated-table>
                        <app-be-paginated-table *ngIf="showLegalSearchForm" class="w-100" [dataSource]="dataSource" [tableKeys]="tableKeysLegal"
                            (itemSelected)="onItemSelected($event)" (changeRequested)="onTableChange($event)" (actionSelected)="actionSelected($event)">
                        </app-be-paginated-table>
                    </app-basic-card>
                </ng-container>
                <ng-container *ngIf="noSubject">
                    <div class="mt-4 d-flex text-center flex-column align-items-center">
                        <mat-icon class="no-results-icon" aria-hidden="false" aria-label="no-subjects-icon"
                            fontIcon="no_accounts"></mat-icon>
                        <h4 class="no-docs-text">Nessun soggetto trovato</h4>
                    </div>
                </ng-container>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <button mat-raised-button [color]="'warn'" (click)="close()">Chiudi</button>
        <button mat-raised-button [color]="'primary'" [disabled]="isConfirmButtonDisabled" (click)="confirm()">Conferma</button>
    </div>
</div>